/**
 * @file コンポーネント：フル動画ページ機器広告問い合わせ確認モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "cancel",
                    onClick: (e) => {
                        e.preventDefault();
                        props.setIsOpenModalAdConfirm(false);
                    },
                    text: localized["Label.Cancel"],
                },
                {
                    buttonType: "submit",
                    onClick: (e) => props.fnOnClickAgree(e),
                    text: localized["Label.Agree"],
                },
            ]}
            content={[
                <Paragraph
                    key="content"
                    onColor="white"
                    text={localized["Label.ConfSendPersonalnformation"]}
                />,
            ]}
            hasButtonClose={true}
            isShow={props.isOpenModalAdConfirm}
            setIsShow={props.setIsOpenModalAdConfirm}
        />
    );
};
